import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=a51e1900&scoped=true&"
import script from "./tabList.vue?vue&type=script&lang=js&"
export * from "./tabList.vue?vue&type=script&lang=js&"
import style0 from "./tabList.vue?vue&type=style&index=0&id=a51e1900&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51e1900",
  null
  
)

export default component.exports